import { render, staticRenderFns } from "./pane.vue?vue&type=template&id=716464d2&"
import script from "./pane.vue?vue&type=script&lang=js&"
export * from "./pane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pane.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/base/tabs/pane.vue
// module id = 158
// module chunks = 0